import { SearchInput } from '@/components/common/SearchInput';
import { ATTENDANCE_PERMISSIONS } from '@/constants/permissions';
import { DataTable } from '@/components/common/DataTable';
import { ErrorState } from '@/components/common/ErrorState';
import { ExportButton } from '@/components/common/ExportButton';
import { PageTitle } from '@/components/layout/PageTitle';
import { PageToolbar } from '@/components/layout/PageToolbar';
import { FIT_TO_SCREEN_PAGE_CLASS } from '@/components/layout/page.constants';
import { StatCardGrid } from '@/components/common/StatCardGrid';
import { DatePickerInput } from '@/components/common/DatePickerInput';
import { Button } from '@/components/ui/button';
import { downloadDailyDashboard } from '../api/attendance.api';
import { useDailyDashboardPage } from '../hooks/useDailyDashboardPage';

const DAILY_DASHBOARD_TITLE = 'Daily Attendance Dashboard';

export function DailyDashboardPage() {
  const {
    date,
    setDate,
    today,
    isActive,
    setIsActive,
    searchText,
    setSearchText,
    filtered,
    summary,
    columns,
    isLoading,
    error,
    refetch,
  } = useDailyDashboardPage();

  return (
    <div className={FIT_TO_SCREEN_PAGE_CLASS}>
      <PageTitle>{DAILY_DASHBOARD_TITLE}</PageTitle>
      <PageToolbar currentTitle={DAILY_DASHBOARD_TITLE} className="order-1 lg:order-0">
        <SearchInput
          value={searchText}
          onChange={setSearchText}
          placeholder="Search by name, ID or mobile"
        />
        <div className="inline-flex overflow-hidden rounded-md border">
          <Button
            type="button"
            size="sm"
            variant={isActive ? 'default' : 'ghost'}
            className="rounded-none"
            onClick={() => setIsActive(true)}
          >
            Active
          </Button>
          <Button
            type="button"
            size="sm"
            variant={isActive ? 'ghost' : 'default'}
            className="rounded-none"
            onClick={() => setIsActive(false)}
          >
            Inactive
          </Button>
        </div>
        <DatePickerInput value={date} onChange={setDate} maxDate={today} />
        <ExportButton
          onExport={() => downloadDailyDashboard({ date, isActive })}
          requires={ATTENDANCE_PERMISSIONS.DAILY_DASHBOARD_EXPORT}
        />
      </PageToolbar>
      {error ? (
        <ErrorState
          error={error}
          fallbackTitle="Could not load attendance"
          onRetry={() => void refetch()}
          fill
          className="order-4 lg:order-0"
        />
      ) : (
        <>
          <div className="order-2 lg:order-0">
            <StatCardGrid stats={summary} isLoading={isLoading} />
          </div>
          <DataTable
            data={filtered}
            columns={columns}
            isLoading={isLoading}
            stickyColumnId="zmName"
            className="order-4 lg:order-0 lg:flex-1"
          />
        </>
      )}
    </div>
  );
}
